import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, ArrowUp } from "lucide-react";
import { waLink } from "../../data";
import { scrollToId } from "./primitives";

export default function Floating() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a
        data-testid="whatsapp-float"
        href={waLink()}
        target="_blank" rel="noreferrer"
        className="fixed bottom-6 right-6 z-50 h-14 w-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-xl shadow-black/20 hover:scale-110 transition-transform"
        aria-label="WhatsApp"
      >
        <MessageCircle className="h-7 w-7" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      </a>

      <AnimatePresence>
        {show && (
          <motion.button
            data-testid="scroll-top"
            initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.6 }}
            onClick={() => scrollToId("#top")}
            className="fixed bottom-24 right-6 z-50 h-11 w-11 grid place-items-center rounded-full backdrop-blur-xl bg-background/70 border border-border/15 hover:border-primary hover:text-primary transition-colors"
            aria-label="Scroll to top"
          >
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
            className="fixed bottom-0 inset-x-0 z-40 sm:hidden px-4 pb-4"
          >
            <button
              data-testid="sticky-cta"
              onClick={() => scrollToId("#contact")}
              className="w-full rounded-full h-14 bg-brand-gradient text-white font-semibold shadow-2xl"
            >
              Get Free Consultation
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
